"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountdownNotification = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactToastNotifications = require("react-toast-notifications");
var _Countdown = _interopRequireDefault(require("../../Countdown/Countdown"));
var _Link = _interopRequireDefault(require("../../Link/Link"));
var _Alert = _interopRequireDefault(require("../../Alert/Alert"));
var _envConstants = require("../../../env-constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _renderer = function renderer(_ref, completedText, countdownText) {
  var days = _ref.days,
    hours = _ref.hours,
    minutes = _ref.minutes,
    seconds = _ref.seconds,
    completed = _ref.completed;
  if (completed) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, completedText);
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, !!days && "".concat(days, "d "), hours, "h ", minutes, "m ", seconds, "s ", countdownText, " ", /*#__PURE__*/_react["default"].createElement("br", null));
};
// I removed `moment(countdown)` from here so we gonna be able to pass whatever we need into this component
// either on content we can pass using moment without '.utc' with datetime format specifying timezone countdown={moment('16 Sep 2021 15:00:00 GMT+1')}
// or from Symfony with UTC countdown={moment.utc('19-08-2021 17:00')}
var CountdownNotification = exports.CountdownNotification = function CountdownNotification(_ref2) {
  var countdown = _ref2.countdown,
    useAlert = _ref2.useAlert,
    className = _ref2.className,
    completedText = _ref2.completedText,
    countdownText = _ref2.countdownText;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useToasts = (0, _reactToastNotifications.useToasts)(),
    addToast = _useToasts.addToast;
  (0, _react.useEffect)(function () {
    if (!useAlert) addToast( /*#__PURE__*/_react["default"].createElement(_Countdown["default"], {
      countdown: countdown,
      renderer: function renderer(renderProps) {
        return _renderer(renderProps, completedText, countdownText);
      }
    }), {
      type: 'info'
    });
  }, []);
  if (useAlert) {
    return /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
      className: className,
      type: "info",
      show: show,
      onClose: function onClose() {
        return setShow(false);
      },
      text: function text() {
        return /*#__PURE__*/_react["default"].createElement(_Countdown["default"], {
          countdown: countdown,
          renderer: function renderer(renderProps) {
            return _renderer(renderProps, completedText, countdownText);
          }
        });
      }
    });
  }
  return null;
};
CountdownNotification.propTypes = {
  countdown: _propTypes["default"].string.isRequired,
  useAlert: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  completedText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  countdownText: _propTypes["default"].string
};
CountdownNotification.defaultProps = {
  completedText: /*#__PURE__*/_react["default"].createElement("span", null, "Bookings open! ", /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: _envConstants.ENV.SITE === 'tyw' ? '/browse' : '/book'
  }, "Book now")),
  countdownText: 'until bookings open!'
};